import "./bootstrap";
import "../css/app.css";
import "vue-select/dist/vue-select.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import Markdown from "vue3-markdown-it";
import { VueReCaptcha } from "vue-recaptcha-v3";
import vSelect from "vue-select";
import * as Sentry from "@sentry/vue";
import Layout from "@/Layout/Layout.vue";

createInertiaApp({
  resolve: (name) => {
    const page = resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob("./Pages/**/*.vue"),
    );
    page.then((module) => {
      if (module.default.layout === undefined) {
        module.default.layout = Layout;
      }
    });
    return page;
  },
  setup({ el, App, props, plugin }) {
    const siteKey = props.initialPage.props.recaptcha_site_key;
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(Markdown)
      .use(VueReCaptcha, {
        siteKey: siteKey,
        loaderOptions: { useRecaptchaNet: true },
      })
      .use(ZiggyVue)
      .component("v-select", vSelect);

    const propagationTargets = import.meta.env.VITE_SENTRY_PROPAGATION_TARGETS
      ? import.meta.env.VITE_SENTRY_PROPAGATION_TARGETS.split(",")
      : [];

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: propagationTargets,
    });

    app.mount(el);

    return app;
  },
  progress: {
    color: "#4B5563",
  },
});
